import "../../stylesheets2025/Committee.css";

const Committee = () => {
    return (
        <div className="committee-container">
            <header className="committee-header">
                <h1>Conference Committee Members</h1>
            </header>

            <section className="committee-section">
                <h2 className="committee-section-title">Chief Patron</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Shirish Kedare</h3>
                        <p>Director, IIT Bombay</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Patron</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Gauranga Das</h3>
                        <p>Director, Govardhan EcoVillage</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">General Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Amarendra Edpuganti, IIT Kanpur</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr VSK Murthy Balijepalli</h3>
                        <p>Chairman, IEEE PES India Chapters Council</p>
                        <p>CEO, LUCES INNOVATION CONSULTING</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof. Pradip P. Kalbar</h3>
                        <p>PIC GESH, IIT Bombay</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Organizing Chairs</h2>

                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Gururaj Mirle Vishwanath, IIT Kanpur</h3>
                        <p>IIT Kanpur</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr. Wazeem Nishad, GESH IIT Bombay</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Harikrishna, NIT Warangal</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Mr Chaitanya Rupa Das, Deputy Director, GEV</h3>
                        <p>Govardhan EcoVillage (GEV)</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Krishnam Raju S</h3>
                        <p>VNIT Nagpur</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Pennan Chinnasamy</h3>
                        <p>IIT Bombay</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Conference Secretaries</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3> Dr. Chitra Pandey</h3>
                        <p>IIT Bombay</p>
                    </div>
                    <div className="committee-card">
                        <h3>Pavan M</h3>
                        <p>IIT Bombay, GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Himani Muppalla</h3>
                        <p>GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Vivek Dalvi</h3>
                        <p>GESH IIT Bombay</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Finance Chair</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Chaitanya Rupa Das</h3>
                        <p>GEV</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Technical Program Committee Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Harikrishna (Water)</h3>
                        <p>NIT Warangal</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Srinivasa Krishna Addepalli (Energy)</h3>
                        <p>IIT Tirupati</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Pavan Totla (Waste Management)</h3>
                        <p>NICMAR Pune</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Sameer Rahatekar (Waste Management)</h3>
                        <p>Cranfield University</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Vikram Vishal (Climate)</h3>
                        <p>IIT Bombay</p>
                    </div>
                </div>
            </section>

            <header className="committee-header">
                <h1>Track Chair</h1>
            </header>

            <section className="committee-section">
                <h2 className="committee-section-title">Water</h2>
                <div className="committee-grid">

                    <div className="committee-card">
                        <h3>Dr Ajey Kumar Patel</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr. Kamalini Devi</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr. Laxmipriya Mohanty</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof P. Hari Prasad Reddy</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr P. Sridhar</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof P. Venkateswara Rao</h3>
                        <p>NIT Warangal</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr. Vema Vamsi Krishna</h3>
                        <p>NIT Warangal</p>
                    </div>

                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Energy</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Srinivas Karthik Yadavalli</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Laltu Chandra</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Sayan Kar</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Prabodh Bajpai</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Rashmi Prasad</h3>
                        <p>NIT Rourkela</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Krishna Murari</h3>
                        <p>IIT Bhilai</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Utsab Kundu</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Piyush Kanth</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Suvendu Samantha</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Soumyabrata Roy</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Prashant Kumar</h3>
                        <p>DY Patil University</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Ankit Raut</h3>
                        <p>FEV Group GMBH</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr Rahul Kumar Sevakula</h3>
                        <p>Whoop Inc., USA</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Mohan SC</h3>
                        <p>BITS Pilani Hyderabad Campus</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Subhashree Choudhury</h3>
                        <p>SOA, Bhubaneswar</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Waste Management</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Pavan Totla</h3>
                        <p>NICMAR University</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Vivek Verma</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Praveen Kumar</h3>
                        <p>VNIT Nagpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Deepak K</h3>
                        <p>IIT BHU</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Climate</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Soumyabrata Roy</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Sayan Kar</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Deepika Swami</h3>
                        <p>IIT Kanpur</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Publication Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Phaneendra Babu Bobba</h3>
                        <p>GRIET Hyderabad</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Sponsorship Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Hari Krishna P</h3>
                        <p>NIT Warangal</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">WIE Chairs (Women in Engineering)</h2>
                <div className="committee-grid committee-grid--single-row">
                    <div className="committee-card">
                        <h3>Prof Swati Manohar</h3>
                        <p>IIT Bombay</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Narasamma</h3>
                        <p>IIT Tirupati</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Plenary Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Lalan Kumar</h3>
                        <p>IIT Delhi</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Hospitality Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Shreejesh</h3>
                        <p>GESH</p>
                    </div>
                    <div className="committee-card">
                        <h3>Pallavi Priya</h3>
                        <p>GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Renuka Kottawar</h3>
                        <p>GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Bhaavya Khatri</h3>
                        <p>GEV</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Student Activity &amp; Awards Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Arjun Ramachandra</h3>
                        <p>IIM Bangalore</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">Publicity Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Rahul Raut</h3>
                        <p>GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Suyog Dhasade</h3>
                        <p>GEV</p>
                    </div>
                    <div className="committee-card">
                        <h3>Ram Thangaraj</h3>
                        <p>GEV</p>
                    </div>
                </div>
            </section>



            <section className="committee-section">
                <h2 className="committee-section-title">Steering Committee Chair</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Vasudev Das</h3>
                        <p>GEV</p>
                    </div>

                    <div className="committee-card">
                        <h3>Dr. Wazeem Nishad</h3>
                        <p>GESH IIT Bombay</p>
                    </div>
                </div>
            </section>

            {/* <section className="committee-section">
                <h2 className="committee-section-title">Institute Advisory Committee Chairs</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Ganesh Ramakrishnan</h3>
                        <p>IIT Bombay</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Milind Rane</h3>
                        <p>IIT Bombay</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof. Sanjay Mahajani</h3>
                        <p>IIT Bombay, Professor In-Charge GESH</p>
                    </div>
                </div>
            </section> */}


            <section className="committee-section">
                <h2 className="committee-section-title">National Advisory Committee Members</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Ashish Garg</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Sachchida Nand Tripathi</h3>
                        <p>IIT Kanpur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof NP Padhy</h3>
                        <p>MNIT Jaipur</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Ganesh Ramakrishnan</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Milind Ranade</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Sanjay Mahajani</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Trupti Mishra</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Anuradda Ganesh</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Satish Agnihotri</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Prasad Modak</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof C. Subramanian</h3>
                        <p>IIT Bombay</p>
                    </div>

                    <div className="committee-card">
                        <h3>Prof Yogendra Shastri</h3>
                        <p>IIT Bombay</p>
                    </div>
                </div>
            </section>

            <section className="committee-section">
                <h2 className="committee-section-title">International Advisory Committee Members</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Prof Akshay Kumar Rathore</h3>
                        <p>Professor, NUS Singapore</p>
                    </div>
                    <div className="committee-card">
                        <h3>Prof Vinod Khadkikar</h3>
                        <p>Professor, Khalifa University, Abu Dhabi</p>
                    </div>
                    <div className="committee-card">
                        <h3>Dr. Raghuveera Manikantachari</h3>
                        <p>Cadence, USA</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Committee;
